import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ProductsComponent } from './products/products.component';
import { ProductComponent } from './products/product/product.component';
import { ConnectComponent } from './connect/connect.component';
import { CategoryComponent } from './products/category/category.component';

import { HomeResolver } from './home/home.resolver';
import { CatalogComponent } from './catalog/catalog.component';
import { AuthGuard } from './auth.guard';
import { RosettaCatalogComponent  } from './rosetta-catalog/rosetta-catalog.component';


const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'portfolio', component: PortfolioComponent },
  { path: 'products', component: ProductsComponent },
  { path: 'material/:cat', component: CategoryComponent },
  { path: 'products/:id', component: ProductComponent },
  { path: 'catalog', component: CatalogComponent, },
  { path: 'rosetta-catalog', component: RosettaCatalogComponent, },

  // {
  //   path: 'products/:cat', component: CategoryComponent,
  //   children: [
  //     { path: ':id', component: ProductComponent }
  //   ]
  // },
  // { path: 'products/:cat/:id', component: ProductComponent },
  { path: 'connect', component: ConnectComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/app-routing.module.ts